class AudioService {
  private audio: HTMLAudioElement;
  
  constructor() {
    this.audio = new Audio('/assets/audio/space-ambient.mp3');
    this.audio.loop = true;
    this.audio.volume = 0.5; // Set initial volume to 50%
  }

  async init() {
    try {
      // Try to autoplay
      await this.audio.play();
      return true;
    } catch (error) {
      // Browser might block autoplay
      console.log('Autoplay blocked by browser. User interaction needed.');
      return false;
    }
  }

  play() {
    return this.audio.play();
  }

  pause() {
    this.audio.pause();
  }

  setVolume(volume: number) {
    this.audio.volume = Math.max(0, Math.min(1, volume));
  }

  isPlaying() {
    return !this.audio.paused;
  }
}

export const audioService = new AudioService(); 